import { gql, TypedDocumentNode } from "@apollo/client";
import { CRMNote } from "@/types";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";
import { PageInfo } from "@/components/Pagination/Pagination";

export interface EventNotesQueryResponse {
  eventNotes: {
    nodes: CRMNote[];
    totalCount: number;
    pageInfo: PageInfo;
  };
}

export const EVENT_NOTES_QUERY: TypedDocumentNode<EventNotesQueryResponse> = gql`
  query EventNotesQuery(
    $slug: String!
    $first: Int
    $last: Int
    $after: String
    $before: String
    $input: BackofficeCRMNotesInput
    $orderBy: BackofficeCRMNoteOrderByInput
  ) {
    eventNotes(
      slug: $slug
      first: $first
      last: $last
      after: $after
      before: $before
      input: $input
      orderBy: $orderBy
    ) {
      nodes {
        ...CRMNoteFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;
